var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('Container',[_c('p',{staticClass:"copyright"},[_vm._v("©"+_vm._s(_vm.date.getFullYear())+" by TopExperts")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }